import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedName from 'I18n/components/FormattedName';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIMediaObject from 'UIComponents/layout/UIMediaObject';
import UIList from 'UIComponents/list/UIList';
import Small from 'UIComponents/elements/Small'; // @ts-expect-error untyped import

import UIAvatar from 'ui-addon-avatars/UIAvatar';
import Review from '../records/Review';
import { PREFER_NOT_TO_SAY } from '../constants/CompanySize';
export default function ReviewerInfo({
  inline = false,
  review
}) {
  const {
    avatarUrl,
    companyName,
    showAvatar,
    reviewerDisplayName,
    industry,
    employees,
    offeringVersion
  } = review;
  const renderedName = useMemo(() => {
    if (reviewerDisplayName) {
      return /*#__PURE__*/_jsx(FormattedName, {
        name: reviewerDisplayName
      });
    }

    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "marketplace-ui-reviews.defaultName"
    });
  }, [reviewerDisplayName]);
  const renderedReviewerInfoText = useMemo(() => {
    const showEmployees = employees && employees !== PREFER_NOT_TO_SAY;
    const showIndustry = industry && industry !== PREFER_NOT_TO_SAY;
    const employeeString = Review.toEmployeeString(employees);

    if (inline) {
      return /*#__PURE__*/_jsxs(UIList, {
        inline: true,
        use: "inline-divided",
        children: [/*#__PURE__*/_jsx("span", {
          className: "is--heading-7 m-bottom-0",
          children: renderedName
        }), showIndustry && /*#__PURE__*/_jsx(Small, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `marketplace-ui-reviews.industry.${industry}`
          })
        }), showEmployees && /*#__PURE__*/_jsx(Small, {
          children: employeeString
        }), offeringVersion && /*#__PURE__*/_jsx(Small, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplace-ui-reviews.versionInfoText",
            options: {
              offeringVersion
            }
          })
        })]
      });
    }

    return /*#__PURE__*/_jsxs(UIFlex, {
      direction: "column",
      children: [/*#__PURE__*/_jsx("span", {
        className: "is--heading-7 m-bottom-1",
        children: renderedName
      }), showIndustry && /*#__PURE__*/_jsx(Small, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `marketplace-ui-reviews.industry.${industry}`
        })
      }), showEmployees && /*#__PURE__*/_jsx(Small, {
        children: employeeString
      }), offeringVersion && /*#__PURE__*/_jsx(Small, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-ui-reviews.versionInfoText",
          options: {
            offeringVersion
          }
        })
      })]
    });
  }, [inline, renderedName, industry, employees, offeringVersion]);
  const renderedUserAvatar = useMemo(() => {
    const avatarSize = inline ? 'xs' : 'md';

    if (avatarUrl && showAvatar) {
      return /*#__PURE__*/_jsx(UIAvatar, {
        type: "contact",
        size: avatarSize,
        src: avatarUrl
      });
    } else {
      return /*#__PURE__*/_jsx(UIAvatar, {
        type: "contact",
        size: avatarSize
      });
    }
  }, [inline, avatarUrl, showAvatar]);

  if (companyName) {
    const displayName = reviewerDisplayName || I18n.text('marketplace-ui-reviews.defaultName');
    return /*#__PURE__*/_jsx("div", {
      style: {
        fontWeight: 600
      },
      className: "vr-hidden",
      children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "marketplace-ui-reviews.reviewerInfo_jsx",
        options: {
          displayName,
          companyName
        },
        elements: {
          Name: FormattedName
        }
      })
    });
  }

  return /*#__PURE__*/_jsx(UIMediaObject, {
    align: "center",
    className: "vr-hidden",
    itemLeft: renderedUserAvatar,
    "data-test-id": "reviewer-info",
    children: renderedReviewerInfoText
  });
}